import DIApi from './_diApi';

class VoucherTypeAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'VoucherTypes';
}

export default new VoucherTypeAPI();
